var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTogglerGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 27C21.15 27 27 21.15 27 14C27 6.85 21.15 1 14 1C6.85 1 1 6.85 1 14C1 21.15 6.85 27 14 27Z",
    stroke: "#01684A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.1956 14H19.2071",
    stroke: "#01684A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.9941 14H14.0058",
    stroke: "#01684A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.79297 14H8.80464",
    stroke: "#01684A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogglerGreen);
export default __webpack_public_path__ + "static/media/toggler-green.1081268815a2e49846f6306feed968d6.svg";
export { ForwardRef as ReactComponent };